import React, { useState, Component } from 'react';
/**
 * Studio Root Component
 * Professional creative tool launcher and environment
 */
import { motion, AnimatePresence } from 'framer-motion';
import { useTheme } from '../../../core/contexts/ThemeContext';
import { StudioLauncher } from './StudioLauncher';
import { VideoStudioApp } from './environments/VideoStudioApp';
import { VibeCodingStudioApp } from './environments/VibeCodingStudioApp';
export type StudioMode = 'launcher' | 'video' | 'coding';
export function StudioRoot() {
  const {
    getThemeClasses
  } = useTheme();
  const theme = getThemeClasses();
  const [activeStudio, setActiveStudio] = useState<StudioMode>('launcher');
  const handleStudioSelect = (mode: 'video' | 'coding') => {
    setActiveStudio(mode);
  };
  const handleBackToLauncher = () => {
    setActiveStudio('launcher');
  };
  return (
    // FIX: Gebruik h-screen en overflow-y-auto om scrollen toe te staan.
    <div className={`h-screen overflow-y-auto ${theme.text} ${theme.bg}`} data-id="element-830">
      <AnimatePresence mode="wait" data-id="element-831">
        {activeStudio === 'launcher' && <StudioLauncher key="launcher" onSelectStudio={handleStudioSelect} data-id="element-832" />}
        {activeStudio === 'video' && <VideoStudioApp key="video" onBack={handleBackToLauncher} data-id="element-833" />}
        {activeStudio === 'coding' && <VibeCodingStudioApp key="coding" onBack={handleBackToLauncher} data-id="element-834" />}
      </AnimatePresence>
    </div>
  );
}